import React, { useState, useCallback, useEffect, useContext } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import Modal from "react-modal";
import FormLogin from "./FormLogin";
import FormSignIn from "./FormSignIn";
import FormRequestPassword from "./FormRequestPassword";
import FormNewsletter from "./FormNewsletter";
import { ConfigContext } from "../ConfigContextProvider";
import FormConfigurator from "./FormConfigurator";

const ModalLogin = (props) => {
  const { modalIsOpen, closeModal, appId, email, fMode, eleId, redirect_uri } =
    props;
  const { authentication_config } = useContext(ConfigContext);
  const [mode, setMode] = useState(fMode);
  const [activeTab, setActiveTab] = useState("LOGIN"); // Tab attiva per bedconfigurator

  const onSwitchMode = useCallback(
    (mode) => {
      setMode(mode);
    },
    [fMode]
  );

  const onSwitchTab = useCallback((tab) => {
    setActiveTab(tab);
  }, []);

  // Check if pro=1 parameter exists in URL
  const isProMode = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('pro') === '1';
  };

  useEffect(() => {
    setMode(fMode);
  }, [fMode]);

  // Contenuto comune
  const renderContent = () => (
    <>
      {appId === "3cadconfigurator"  && (
        <div className={`AuthenticationModal__tabs ${!isProMode() ? 'AuthenticationModal__tabs--single' : ''}`}>
          <button
            className={`AuthenticationModal__tab ${
              mode === "BEDCONFIGURATOR"  ? "active" : ""
            }`}
            onClick={() => onSwitchMode("BEDCONFIGURATOR")}
          >
            <FormattedMessage id={appIdLabel + "consumer.title"} />
          </button>
          {isProMode() && (
            <button
              className={`AuthenticationModal__tab ${
                mode === "LOGIN" || mode === "REGISTER" ? "active" : ""
              }`}
              onClick={() => onSwitchMode("LOGIN")}
            >
              <FormattedMessage id={appIdLabel + "business.title"} />
            </button>
          )}
        </div>
      )}

      <div className={`AuthenticationModal__wrapper`}>
        {!(authentication_config && authentication_config.modal === false) && (
          <button
            className="AuthenticationModal__btnClose"
            onClick={() => closeModal()}
          >
            ✕
          </button>
        )}

        <>
          {mode === "PASSWORD" && (
            <FormRequestPassword
              onSwitchMode={onSwitchMode}
              closeModal={closeModal}
              appId={appId}
            />
          )}
          {mode === "LOGIN" && (
            <FormLogin
              onSwitchMode={onSwitchMode}
              closeModal={closeModal}
              appId={appId}
              fMode={fMode}
              redirectUri={redirect_uri}
            />
          )}
          {mode === "REGISTER" && (
            <FormSignIn
              onSwitchMode={onSwitchMode}
              closeModal={closeModal}
              appId={appId}
            />
          )}
          {mode === "BEDCONFIGURATOR" && (
            <>
              <FormConfigurator
                onSwitchMode={onSwitchMode}
                closeModal={closeModal}
                appId={appId}
                eleId={eleId}
                redirectUri={redirect_uri}
              />
            </>
          )}
          {mode === "NEWSLETTER" && (
            <FormNewsletter
              onSwitchMode={onSwitchMode}
              closeModal={closeModal}
              appId={appId}
              email={email}
            />
          )}
        </>
      </div>
    </>
  );

  // Se modal è false, restituisci solo il contenuto
  if (authentication_config && authentication_config.modal === false) {
    return renderContent();
  }
  const appIdLabel = (appId && appId.length) > 0 ? appId + "." : "";
  // Altrimenti wrappa nella modale
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      className={`AuthenticationModal AuthenticationModal--${String(
        mode
      ).toLowerCase()} AuthenticationModalType--${String(appId).toLowerCase()}`}
      contentLabel="Authentication Modal"
      ariaHideApp={false}
      bodyOpenClassName={mode === "NEWSLETTER" ? "Modal__newsletter" : ""}
    >
      {renderContent()}
    </Modal>
  );
};

export default injectIntl(ModalLogin);
